<template>
  <content-wrapper>
    <Content
        class="mt-3"
    >
      <b-card header-bg-variant="dark">
        <template #header>
          <b-row class="align-items-center justify-content-between">
            <b-col>
              <h6 class="mb-0">User</h6>
            </b-col>
            <b-col md="1">
              <b-button variant="outline-light" @click="add()">
                <b-icon icon="plus-circle-fill"></b-icon>
                Add
              </b-button>
            </b-col>
          </b-row>
        </template>

        <!-- Table Search -->
        <b-row>
          <b-col v-if="isSuperAdmin">
            <b-form-group
                label-for="memberDropdown"
                label="Select Member"
            >
              <MemberDropDown id="memberDropdown"
                              v-model="selectedMember"
                              :member="member"
                              @change="loadUserByMember"
                              :show-super-admin="true"
              ></MemberDropDown>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
                label="Member Status"
                label-for="memberStatus"
            >
              <b-form-radio-group
                  id="memberStatus"
                  buttons
                  button-variant="outline-primary"
                  :options="options.user"
                  name="radios-btn-direction"
                  v-model="searchForm.status"
                  @change="pagination.current = 1;loadUserByMember(selectedMember)"
                  class="mb-3"
              >
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-table :per-page="pagination.per_page"
                 :current-page="pagination.current"
                 ref="table"
                 :items="loadPage"
                 :fields="columns"
                 :busy.sync="isLoading"
                 striped
                 borderless
                 outlined
                 hover
                 show-empty
                 empty-text="No records found..."
                 stacked="sm"
                 class="mb-3"
        >
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner label="Loading..." type="grow"></b-spinner>
            </div>
          </template>
          <!-- full detail on click -->
          <template #row-details="row">
            <b-card>
              <b-row class="mb-2">
                <b-col
                    md="6"
                    class="mb-1"
                >
                  <dl>
                    <dt>Company Name</dt>
                    <dd>{{ row.item.company_name }}</dd>
                    <dt>NIB</dt>
                    <dd>{{ row.item.NIB }}</dd>
                    <dt>NPWP</dt>
                    <dd>{{ row.item.NPWP }}</dd>
                  </dl>
                </b-col>
                <b-col
                    md="6"
                    class="mb-1"
                >
                  <dl>
                    <dt>Expiry</dt>
                    <dd>{{ typeof row.item.expiry === 'string' ? row.item.expiry.replace(/\+.*/, '') : '-' }}</dd>
                    <dt>Renewal</dt>
                    <dd>{{ typeof row.item.renewal === 'string' ? row.item.renewal.replace(/\+.*/, '') : '-' }}</dd>
                    <dt>Status</dt>
                    <dd>
                      <b-badge :variant="status[0][row.item.status]">
                        {{ status[1][row.item.status] }}
                      </b-badge>
                    </dd>
                  </dl>
                </b-col>
              </b-row>

              <b-button
                  size="sm"
                  variant="outline-secondary"
                  @click="row.toggleDetails"
              >
                Hide Details
              </b-button>
            </b-card>
          </template>
          <template #cell(status)="data">
            <b-badge :variant="status[0][data.value]">
              {{ status[1][data.value] }}
            </b-badge>
          </template>
          <template #cell(actions)="data">
            <b-button-group size="sm">
              <b-button
                  :variant="data.item.status === 1 ? 'secondary' : 'info' "
                  @click="setStatus(data.item)"
              >{{ data.item.status === 1 ? 'Disable Me' : 'Enable Me' }}
              </b-button>
            </b-button-group>
          </template>
        </b-table>
        <div class="form-group row justify-content-end">
          <label class="col-sm-1 col-form-label">Per Page</label>
          <div class="col-sm-1 mb-3">
            <b-form-select
                :value="pagination.per_page"
                :options="options.pagination"
                @change="(v) => {pagination.per_page = v; pagination.current = 1}"
            ></b-form-select>
          </div>
          <div class="pr-2">
            <simple-pagination
                v-model="pagination.current"
                :disable-prev="pagination.current === 1"
                :disable-next="pagination.at_last_page"
            />
          </div>
        </div>
      </b-card>
    </Content>

    <!-- Modals  -->
    <b-modal
        header-bg-variant="secondary"
        centered id="formModal" size="lg"
        title="User Form"
        no-close-on-esc
        hide-header-close
        no-close-on-backdrop
    >
      <b-form-group
          label="Member"
          label-for="member"
          v-if="isSuperAdmin"
      >
        <MemberDropDown
            @change="setMember"
            :member="member"
        ></MemberDropDown>
      </b-form-group>
      <b-row>
        <b-col>
          <b-form-group
              label="Username"
              label-for="username"
              label-class="required"
          >
            <b-form-input
                id="username"
                v-model="$v.user.username.$model"
                required
                type="text"
                :state="validateState('username')"
            ></b-form-input>
            <b-form-invalid-feedback>
              This is a required field and must be at least 3 characters.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
              label="Email"
              label-for="email"
              label-class="required"
          >
            <b-form-input
                id="email"
                v-model="$v.user.user_mail.$model"
                type="email"
                :state="validateState('user_mail')"
            ></b-form-input>
            <b-form-invalid-feedback>
              This is a required field, must be at least 5 characters and a valid email.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
              label="Access Level"
              label-for="level"
              label-class="required"
          >
            <b-form-select
                :options="level"
                v-model="$v.user.level.$model"
            ></b-form-select>
            <b-form-invalid-feedback>
              This is a required field
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <template #modal-footer="{ cancel }">
        <b-button variant="primary" :disabled="isSubmitting" @click="submit()">
          Submit
          <b-spinner v-if="isSubmitting" small></b-spinner>
        </b-button>
        <b-button variant="secondary" @click="clearForm();cancel()">
          Forget it
        </b-button>
      </template>
    </b-modal>
    <!-- Credential Modal -->
    <b-modal centered header-bg-variant="success" id="credential" size="sm" title="Keep this password" ok-only
             no-close-on-backdrop>
      <h4>Please save this Password</h4>
      <h1 class="text-center">{{ password }}</h1>
      <template #modal-footer="{ cancel }">
        <b-button variant="primary" @click="password=null;cancel()">
          OK!
        </b-button>
      </template>
    </b-modal>
  </content-wrapper>
</template>

<script>
import MemberDropDown from "@/components/composable/MemberDropDown";
import {
  BIcon,
  BIconPlusCircleFill,
} from "bootstrap-vue";
import {addUser, listUser, setUserStatus} from "@/services/users";
import {validationMixin} from "vuelidate";
import {required, minLength, email} from "vuelidate/lib/validators";
import {userInfoMixin} from "@/mixins/userInfoMixin";
import SimplePagination from "@/components/SimplePagination";

export default {
  name: "UserList",
  components: {
    MemberDropDown,
    BIcon,
    // eslint-disable-next-line vue/no-unused-components
    BIconPlusCircleFill,
    SimplePagination,
  },
  mixins: [validationMixin, userInfoMixin],
  validations: {
    user: {
      username: {
        required,
        minLength: minLength(3),
      },
      user_mail: {
        required,
        minLength: minLength(5),
        email,
      },
      level: {
        required,
      },
    },
  },
  data: () => ({
    options: {
      user: [
        {text: 'NEW', value: 0}, // newly created user, and not yet activate
        {text: 'ACTIVE', value: 1},
        {text: 'INACTIVE', value: 2},
      ],
      pagination: [
        10,
        20,
        30,
        40,
        50,
        80,
        100,
      ],
    },
    columns: [
      {
        key: 'id',
        label: 'ID',
      },
      {
        key: 'username',
        label: 'Username',
      },
      {
        key: 'user_mail',
        label: 'Email',
      },
      {
        key: 'level',
        label: 'Level',
      },
      {
        key: 'status',
        label: 'Status',
      },
      {
        key: 'actions',
        label: 'Actions',
      },
    ],
    items: [],
    isLoading: false,
    status: [
      {0: 'danger', 1: 'primary', 2: 'danger',},
      {0: 'NEW', 1: 'Enable', 2: 'Inactive'},
    ],
    user: {
      username: "",
      level: 2, // blm tau apa ini, sementara fix 1 dulu
      user_type: 1, // ini jg fix 1 dulu
      user_mail: "",
    },
    isSubmitting: false,
    password: null,
    pagination: {
      current: 1,
      last_page: 15,
      total_items: 0,
      per_page: 10,
      at_last_page: false,
    },
    searchForm: {
      keywords: null,
      type: null,
      status: 0,
    },
  }),
  methods: {
    loadUserByMember(member) {
      this.selectedMember = member;
      this.$refs.table.refresh();
    },
    edit(user) {
      this.user = user;
      this.user = {
        username: user.username,
        level: user.level, // blm tau apa ini, sementara fix 1 dulu
        user_type: user.user_type, // ini jg fix 1 dulu
        user_mail: user.user_mail,
      };
      this.$bvModal.show('formModal')
    },
    async setStatus(user) {
      this.isLoading = true;
      const status = user.status !== 1 ? 1 : 2;
      await setUserStatus({username: user.username, status,})
      this.isLoading = false;
      this.$bvToast.toast(`${user.username} Status Updated!`, {
        title: 'Congratulation!',
        autoHideDelay: 1500,
        variant: 'success',
      })
      this.$nextTick(() => {
        this.$refs.table.refresh();
      });
    },
    clearForm() {
      this.user = {
        member: 0,
        username: "",
        level: 2, // blm tau apa ini, sementara fix 1 dulu
        user_type: 1, // ini jg fix 1 dulu
        user_mail: "",
      };
      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    async submit() {
      try {
        this.$v.user.$touch();
        if (this.$v.user.$anyError) {
          this.$bvToast.toast(`Missing required information!`, {
            title: 'Error!',
            autoHideDelay: 1500,
            variant: 'danger',
          })
          return;
        }
        this.isSubmitting = true;
        const {data: {data: {user}}} = await addUser(this.user)

        this.$bvToast.toast(`${this.user.username} saved successfully!`, {
          title: 'Congratulation!',
          autoHideDelay: 1500,
          variant: 'success',
        })
        this.password = user.paswd;
        this.$bvModal.hide('formModal')
        this.clearForm();
        this.$bvModal.show('credential')
        this.loadUserByMember(this.selectedMember)
        this.isSubmitting = false
      } catch (err) {
        this.isSubmitting = false;
        this.$nextTick(() => {
          this.$v.$reset();
        });
      }
    },
    add() {
      this.clearForm();
      if (!this.isSuperAdmin) {
        this.user.member = this.member.id
      }
      this.$bvModal.show('formModal')
    },
    validate() {
      return true;
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.user[name];
      return $dirty ? !$error : null;
    },
    setMember(member) {
      delete this.user.member
      if (member !== null) {
        this.user.member = member.id
      }
    },
    async loadPage(ctx){
      try {
        this.isLoading = true;
        const {data: {data: {rows}}} = await listUser(this.searchParams(ctx))
        const items = Array.isArray(rows.user) ? rows.user : [rows.user];
        this.pagination.total_items = items.length
        this.pagination.at_last_page = this.pagination.total_items < this.pagination.per_page;
        this.isLoading = false;
        return items;
      } catch (e) {
        this.isLoading = false;
        this.pagination.at_last_page = true;
        return [];
      }
    },
    searchParams(ctx){
      const searchData = {
        per_page: this.pagination.per_page,
        current_page: this.pagination.current,
        status: this.searchForm.status,
      };
      if (this.selectedMember !== null) {
        searchData['member'] = this.selectedMember.id
      }
      if (ctx.sortBy !== '') {
        const direction = ctx.sortDesc ? 'desc' : 'asc';
        searchData['order_by'] = `${ctx.sortBy},${direction}`;
      }
      return searchData;
    },
  },
  computed: {
    level() {
      const levels = [
        {text: 'Admin', value: 2},
        {text: 'Normal User', value: 3},
      ]
      if (this.isSuperAdmin) {
        levels.unshift({text: 'Super Admin', value: 1,})
        levels.push({text: 'Control Room', value: 4,});
        levels.push({text: 'Gate Pass', value: 5,});
      }
      return levels;
    },
  },
  mounted() {
    if (!this.isSuperAdmin) {
      this.user.member = this.member.id
    }
    this.loadUserByMember(this.member)
  },
}
</script>

<style scoped>

</style>
